import * as moment from "moment";
import axios from "axios";

import { ImmunisationListModel } from "@teamprevent/common/immunisation/models";

class OhCaseApi {

    public async getAll(): Promise<ImmunisationListModel[]> {
        const response = await axios.get("/api/immunisations");
        return response.data.map(this.parseModel);
    }

    private parseModel = (immunisation: ImmunisationListModel): ImmunisationListModel => ({
        ...immunisation,
        dateCompleted: immunisation.dateCompleted && moment(immunisation.dateCompleted)
    });
}

export default new OhCaseApi();
